module.exports = __webpack_public_path__ + "looker.svg?ae74a87055a619588ada0af0a9376f4f";